// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-00e34726] {\n  font-size: 1.1rem;\n}\n.items-wrapper[data-v-00e34726] {\n  min-height: calc(100vh - 78px);\n}\n.items-wrapper.page[data-v-00e34726] {\n    background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
